import { render, staticRenderFns } from "./BankInstallmentCampaignView.vue?vue&type=template&id=5b9e26ce"
import script from "./BankInstallmentCampaignView.vue?vue&type=script&lang=js"
export * from "./BankInstallmentCampaignView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports